module.exports = __webpack_public_path__ + "static/media/characterExplainer44.f2442316.gif";